// Careers Application Form JavaScript
document.addEventListener('DOMContentLoaded', function() {
    const form = document.getElementById('VolleyballCoachApplicationForm');
    
    if (!form) return;
    
    // Handle weekend availability radio buttons and explanation textarea
    const availabilityRadios = form.querySelectorAll('input[name="contact[weekend_availability]"]');
    const availabilityExplanation = form.querySelector('textarea[name="contact[availability_explanation]"]');
    
    availabilityRadios.forEach(radio => {
        radio.addEventListener('change', function() {
            if (this.value === 'Limited') {
                availabilityExplanation.style.display = 'block';
                availabilityExplanation.setAttribute('required', 'required');
            } else {
                availabilityExplanation.style.display = 'none';
                availabilityExplanation.removeAttribute('required');
                availabilityExplanation.value = '';
            }
        });
    });
    
    // Initially hide the explanation textarea
    if (availabilityExplanation) {
        const checkedRadio = form.querySelector('input[name="contact[weekend_availability]"]:checked');
        if (!checkedRadio || checkedRadio.value !== 'Limited') {
            availabilityExplanation.style.display = 'none';
        }
    }
    
    // Validate at least one position is selected
    form.addEventListener('submit', function(e) {
        const headCoach = form.querySelector('input[name="contact[position_head_coach]"]:checked');
        const assistantCoach = form.querySelector('input[name="contact[position_assistant_coach]"]:checked');
        
        if (!headCoach && !assistantCoach) {
            e.preventDefault();
            alert('Please select at least one position you are applying for.');
            
            // Scroll to the position section
            const positionSection = form.querySelector('input[name="contact[position_head_coach]"]').closest('.form-field');
            if (positionSection) {
                positionSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
            
            return false;
        }
    });
    
    // Enhanced form field interactions
    const formInputs = form.querySelectorAll('.form-input');
    
    formInputs.forEach(input => {
        // Add focus styling
        input.addEventListener('focus', function() {
            this.parentElement.classList.add('field-focused');
        });
        
        input.addEventListener('blur', function() {
            this.parentElement.classList.remove('field-focused');
            
            // Add filled class if input has value
            if (this.value.trim() !== '') {
                this.parentElement.classList.add('field-filled');
            } else {
                this.parentElement.classList.remove('field-filled');
            }
        });
        
        // Check initial state
        if (input.value.trim() !== '') {
            input.parentElement.classList.add('field-filled');
        }
    });
    
    // Smooth scroll for internal links - handled globally
    
    // Form success message auto-hide
    const successMessage = form.querySelector('.form-message--success');
    
    if (successMessage) {
        setTimeout(() => {
            successMessage.style.transition = 'opacity 0.5s ease';
            successMessage.style.opacity = '0';
            
            setTimeout(() => {
                successMessage.style.display = 'none';
            }, 500);
        }, 10000); // Hide after 10 seconds
    }
    
    // Phone number formatting
    const phoneInput = form.querySelector('input[type="tel"]');
    
    if (phoneInput) {
        phoneInput.addEventListener('input', function(e) {
            let value = e.target.value.replace(/\D/g, '');
            let formattedValue = '';
            
            if (value.length > 0) {
                if (value.length <= 3) {
                    formattedValue = value;
                } else if (value.length <= 6) {
                    formattedValue = `(${value.slice(0, 3)}) ${value.slice(3)}`;
                } else if (value.length <= 10) {
                    formattedValue = `(${value.slice(0, 3)}) ${value.slice(3, 6)}-${value.slice(6)}`;
                } else {
                    formattedValue = `(${value.slice(0, 3)}) ${value.slice(3, 6)}-${value.slice(6, 10)}`;
                }
            }
            
            e.target.value = formattedValue;
        });
    }
});